<template>
  <div class="relative text-center border rounded-34 overflow-hidden">
    <img class="w-full mb-24" :src="backgroundImage" alt="empty background"></img>
    <div class="w-auto">
      <div class="flex justify-center mb-20">
        <img class="object-cover h-26 lg:h-38" src="/assets/images/logo-sm.png" alt="empty results">
      </div>
      <div class=" mb-16 lg:mb-28 text-center">
        <div class="mb-14">For inquiries on {{ artist.name }}'s works</div>
        <div>Please email us at <span class="text-orange font-bold lowercase">CURATOR@DRYBRUSH.COM</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArtistEmptyArtwork",

  computed: {
    customBackground () {
      return jsonFromPage('#data-empty-background')
    },

    artist () {
      return jsonFromPage('#data-artist')
    },

    backgroundImage () {
      return jsonFromPage('#data-empty-background')
    }
  }
}
</script>
